// extracted by mini-css-extract-plugin
module.exports = {"color":"TableCellMailEquipe_color__2kLFc","mobile":"TableCellMailEquipe_mobile__30jws","desktop":"TableCellMailEquipe_desktop__3apAO"};